var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-template-container",class:_vm.size},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("action")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }